export default __webpack_public_path__ + "static/media/twelve_.62d5868b.jpeg";